export { SearchTips } from './SearchTips';
